import { createFileRoute } from '@tanstack/react-router'
import ComplianceRolesSettings from '@/pages/settings/compliance-roles'

export const Route = createFileRoute(
  '/(protected)/workspaces/$workspaceId/settings/compliance-roles',
)({
  component: ComplianceRolesSettings,
})
